import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);
const designAuditApi = process.env.REACT_APP_DESIGN_AUDIT_BASE_URL;

export const listConversations = async (designReviewUuid, limit = 50, offset = 0) => {
  const url = 'project/conversations';
  const params = {
    design_review: designReviewUuid,
    status: 'active',
    limit,
    offset,
  };

  const { data } = await api.setUrl(url).get(params);

  return data;
};

export const getConversationMessages = async (conversationUuid, limit = 20, beforeSequence = null) => {
  const url = `project/conversations/${conversationUuid}/messages`;
  const params = { limit };

  if (beforeSequence) {
    params.before_sequence = beforeSequence;
  }

  const { data } = await api.setUrl(url).get(params);

  return data;
};

export const sendChatMessage = async ({
  designReviewUuid,
  message,
  conversationId = null,
  onDelta,
  onError,
  onDone,
  signal,
}) => {
  const token = localStorage.getItem('access_token');
  const backendUrl = process.env.REACT_APP_X_BACKEND_URL;

  const body = {
    design_review_uuid: designReviewUuid,
    message,
  };

  if (conversationId) {
    body.conversation_id = conversationId;
  }

  const response = await fetch(`${designAuditApi}/critique_chat`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'X-BACKEND-URL': backendUrl,
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
    },
    body: JSON.stringify(body),
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Request failed' }));

    throw new Error(errorData.message || `HTTP ${response.status}`);
  }

  const reader = response.body.getReader();
  // eslint-disable-next-line compat/compat -- TextDecoder used for SSE stream parsing
  const decoder = new TextDecoder();
  let buffer = '';
  let assistantText = '';
  let newConversationId = null;
  let streamDone = false;

  while (!streamDone) {
    const { value, done } = await reader.read();

    if (done) {
      streamDone = true;
      break;
    }

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');

    buffer = lines.pop();

    for (const line of lines) {
      if (!line.startsWith('data: ')) {
        continue;
      }

      try {
        const event = JSON.parse(line.slice(6));

        if (event.delta) {
          assistantText += event.delta;

          if (onDelta) {
            onDelta(event.delta, assistantText);
          }
        }

        if (event.error) {
          if (onError) {
            onError(event.error);
          }
        }

        if (event.done) {
          newConversationId = event.conversation_id;

          if (onDone) {
            onDone(assistantText, newConversationId);
          }
        }
      }
      catch {
        // Skip malformed SSE lines
      }
    }
  }

  return { assistantText, conversationId: newConversationId };
};

export default {
  listConversations,
  getConversationMessages,
  sendChatMessage,
};
